<template>
  <transition name="fade">
    <VBlock v-if="isOpen" id="toast-layer" :padding="[0, 38, 0, 38]">
      <component :is="name" :text="text" />
    </VBlock>
  </transition>
</template>

<script>
import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'

const requireComponent = require.context('../../organisms/Toasts/.', false, /[\w-].vue$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')))
  Vue.component(componentName, componentConfig.default || componentConfig)
})

export default {
  name: 'ToastLayer',
  props: {
    text: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VBlock
  },
  computed: {
    name() {
      return `ToastAlert`
    }
  }
}
</script>

<style lang="scss" scoped>
#toast-layer {
  position: fixed;
  z-index: 60;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>